import { useState } from "react";
import { useLanguage } from "@/context/LanguageContext";
import { ASSETS } from "@/data/content";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import SectionHeader from "./SectionHeader";
import Reveal from "./Reveal";

export default function Gallery() {
  const { t } = useLanguage();
  const g = t.galeria;
  const photos = [ASSETS.hero, ASSETS.celebration, ASSETS.actionNight, ASSETS.portrait];
  const [selected, setSelected] = useState(null);

  return (
    <section id="galeria" className="mx-auto max-w-7xl scroll-mt-20 px-4 py-20 sm:px-6 sm:py-28 lg:px-8" data-testid="galeria-section">
      <SectionHeader number={`${g.number} · ${t.nav.galeria}`} title={g.title}>
        {g.note}
      </SectionHeader>

      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4" data-testid="gallery-grid">
        {photos.map((src, i) => (
          <Reveal key={src} delay={0.06 * i}>
            <button
              data-testid={`gallery-item-${i}`}
              onClick={() => setSelected(i)}
              className="group relative block w-full overflow-hidden rounded-xl border border-white/10"
            >
              <img
                src={src}
                alt={g.alts[i]}
                loading="lazy"
                className="aspect-[3/4] w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <span className="absolute inset-0 bg-gradient-to-t from-[#07090E]/60 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
              <span className="absolute bottom-3 left-3 font-mono text-[10px] font-semibold uppercase tracking-[0.2em] text-sky-300 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                Foto {String(i + 1).padStart(2, "0")}
              </span>
            </button>
          </Reveal>
        ))}
      </div>

      <Dialog open={selected !== null} onOpenChange={() => setSelected(null)}>
        <DialogContent className="max-w-3xl border-white/10 bg-[#0A0D14] p-2" data-testid="gallery-lightbox">
          {selected !== null && (
            <img src={photos[selected]} alt={g.alts[selected]} className="max-h-[80vh] w-full rounded-lg object-contain" />
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
}
